import cx from "classnames";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: React.ReactNode;
  className?: string;
};

type SocialButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonProps & {
    icon?: string;
  };

export function Button({ className, children, ...rest }: ButtonProps) {
  return (
    <button
      className={cx(
        "cursor-pointer inline-flex items-center justify-center gap-x-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed duration-200 ease-in-out text-white bg-brand-green transition-all hover:bg-brand-green-darker focus:ring-indigo-200 text-lg px-6 py-0 min-w-44 h-12 rounded-[30px] w-full",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}

export function SocialButton({ className, children, icon, ...rest }: SocialButtonProps) {
  return (
    <button
      className={cx(
        "w-[100%] cursor-pointer items-center justify-center gap-x-2 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 ease-in-out bg-white text-gray-900 shadow-sm shadow-gray-500/5 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 py-0 px-5 h-11 rounded-[30px] inline-flex",
        className,
      )}
      {...rest}
    >
      <div className="flex items-center justify-center">
        <img alt="social icon" src={icon} width={24} />
      </div>
      <div className="flex items-center justify-center  min-w-45">{children}</div>
    </button>
  );
}
